import queryString from 'query-string';
import { constructUrl } from '@ynap/url-configuration';

export default function (locale, additionalParams = {}, urlTemplate) {
    const urlQueryString = queryString.stringify({ redirect: window.location.pathname, ...additionalParams }, { strict: false, arrayFormat: 'comma' });
    let loginUrl = `/${locale}/account/login`;
    if (urlTemplate) {
        const legacyLocale = locale.split('-');
        loginUrl = constructUrl(urlTemplate, { COUNTRY: legacyLocale?.[1], LANGUAGE: legacyLocale?.[0] });
    }
    window.location.assign(`${loginUrl}?${urlQueryString}`);
}
